import { __decorate } from "tslib";
import { ClassName } from '@core/shared/class-name';
import { NgxsModule } from '@ngxs/store';
import { AccessibilityState } from './state/accessibility.state';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
let AccessibilityFrontendSharedModule = /*#__PURE__*/(() => {
  let AccessibilityFrontendSharedModule = class AccessibilityFrontendSharedModule {
    static {
      this.ɵfac = function AccessibilityFrontendSharedModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AccessibilityFrontendSharedModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: AccessibilityFrontendSharedModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [NgxsModule.forFeature([AccessibilityState])]
      });
    }
  };
  AccessibilityFrontendSharedModule = __decorate([ClassName("AccessibilityFrontendSharedModule")], AccessibilityFrontendSharedModule);
  return AccessibilityFrontendSharedModule;
})();
export { AccessibilityFrontendSharedModule };